import {
  BridgeProvider as SharedBridgeProvider,
  useBridge,
  type BridgeRegistry,
} from "@indeed/tare/BridgeContext";
import { type PropsWithChildren, useMemo } from "react";

import type {} from "../../bridgeRegistry";
import { RawNativeModules } from "./internal/TypedNativeModules";
import { getTareBridge } from "./tare/getTareBridge";

export { useBridge } from "@indeed/tare/BridgeContext";

/** Host defaults stay outside TARE; explicit and inherited bridges take precedence. */
export function BridgeProvider({
  implementations,
  children,
}: PropsWithChildren<{
  implementations?: Partial<BridgeRegistry>;
}>) {
  const parent = useBridge();
  const bridges = useMemo(
    () => ({
      ...implementations,
      RNTareBridge:
        implementations?.RNTareBridge ?? parent.RNTareBridge ?? getTareBridge() ?? undefined,
      RNJSTNavigator:
        implementations?.RNJSTNavigator ?? parent.RNJSTNavigator ?? RawNativeModules.RNJSTNavigator,
      RNBroadcastModule:
        implementations?.RNBroadcastModule ??
        parent.RNBroadcastModule ??
        RawNativeModules.RNBroadcastModule,
      RNJSTPushAuthorization:
        implementations?.RNJSTPushAuthorization ??
        parent.RNJSTPushAuthorization ??
        RawNativeModules.RNJSTPushAuthorization,
    }),
    [parent, implementations],
  );

  return <SharedBridgeProvider implementations={bridges}>{children}</SharedBridgeProvider>;
}
